// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-bar-content-type{display:flex;background-color:#222c38;border-radius:100px;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
module.exports = exports;
